"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createEmotionCache = require("./createEmotionCache");
Object.keys(_createEmotionCache).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createEmotionCache[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createEmotionCache[key];
    }
  });
});
